<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight4" style="background-size: cover; background-position:center;  "
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'contacts-header.jpg)'}">
        <div class="row">
            <div style="width:10%"></div>
            <div class="text-center whiteText" style="width:80%">
                <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''">
                    <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                        class="DINNextLTPro-Black whiteText headerImageTextLarge" style=" text-transform: uppercase;">
                        CONTACT</h1>
                    <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                        class="DINNextLTPro-Black whiteText headerImageTextLarge" style=" text-transform: uppercase;">
                        GET IN TOUCH WITH THE TEAM</h1>
                </div>
            </div>
            <div style="width:10%"></div>
        </div>
    </div>
</div>
<div class="row text-center mt-5 mb-3">
    <h2 class="Caecilia76BoldItalic greenText" style="font-size:28px; font-weight: 700; ">We Meet You Where You Are</h2>
</div>
<div style="max-width:1350px; margin:auto">
    <div class="row text-center pb-5">
        <div class="col-lg-4 blackText" style="padding-left:50px; padding-right:50px">
            <h4 class="DIN2014Bold blueText mt-3" style="font-size:21px; font-weight: 600;">Local, Experienced Reps
            </h4>
            <h6 class="DIN2014Regular blackText mt-3" style="font-size:19px; line-height:1.5">
                With Harrell’s reps covering all 50 states, you will be connected with an expert in your area who is
                innately aware of your unique growing conditions.
            </h6>
            <h6 class="mt-3"><a class="DIN2014Regular blueText"
                    style="font-size:16px; line-height: 19px; font-weight: 700; text-decoration: underline;"
                    href='/findrep'>FIND YOUR REP ></a>
            </h6>
        </div>
        <div class="col-lg-4 blackText" style="padding-left:50px; padding-right:50px">
            <h4 class="DIN2014Bold blueText mt-3" style="font-size:21px; font-weight: 600;">Regional Warehouses
            </h4>
            <h6 class="DIN2014Regular blackText mt-3" style="font-size:19px; line-height:1.5">
                Harrell’s has warehouse locations across the United States stocked with the products you know and trust
                and
                people to help get them in your hands.
            </h6>
            <h6 class="mt-3"><a class="DIN2014Regular blueText"
                    style="font-size:16px; line-height: 19px; font-weight: 700; text-decoration: underline;"
                    href='/locations'>VIEW OUR WAREHOUSE LOCATIONS + CONTACT INFO ></a>
            </h6>
        </div>
        <div class="col-lg-4 blackText" style="padding-left:50px; padding-right:50px">
            <h4 class="DIN2014Bold blueText mt-3" style="font-size:21px; font-weight: 600;">Corporate Support
            </h4>
            <h6 class="DIN2014Regular blackText mt-3" style="font-size:19px; line-height:1.5">
                Located in Lakeland, Florida, the team at Harrell’s corporate office ensures that your experience with Harrell’s is seamless from start to finish.
            </h6>
            <h6 class="mt-3"><a class="DIN2014Regular blueText"
                    style="font-size:16px; line-height: 19px; font-weight: 700; text-decoration: underline;"
                    href='/teams'>MEET THE TEAM ></a>
            </h6>
        </div>
    </div>
</div>
<div class="blueBackground pt-5 pb-5">
    <div class="row" style="padding-left:50px; padding-right:50px;max-width:1350px; margin:auto">
        <div class="row ml-5 mr-5 mb-5" style="padding-left:3%">
            <h2 class="Caecilia76BoldItalic blueBackground whiteText pt-3"
                style="font-size:28px; font-weight: 700; margin-bottom:0px !important">Contact Information
            </h2>

        </div>
        <div class="col-lg-4  whiteText" style="padding-left:3%">
            <h3 class="DIN2014Bold"
                style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">CORPORATE
                OFFICE +
                DELIVERIES
            </h3>
            <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">
                {{this.dotComService.corpOffice[0].address}}</h5>
            <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">
                {{this.dotComService.corpOffice[0].city}},
                {{this.dotComService.corpOffice[0].state}} {{this.dotComService.corpOffice[0].zip}}</h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">TF:
                <a class="telephoneNmbr" href='tel:800-282-8007'>800-282-8007</a></h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">P: <a class="telephoneNmbr" href='tel:863-687-2774'>863-687-2774</a></h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">F: <a href="javascript: void(0)" style="color:white !important">863-688-8836</a></h5>
            <h3 style="margin-top:20px"><a class="DIN2014Bold whiteBackground greenText"
                    style="cursor:pointer;font-size:20px ;padding:8pt; text-decoration: none !important"
                    (click)="GetDirections(this.dotComService.corpOffice[0])">GET
                    DIRECTIONS</a>
            </h3>
            <h3 class="DIN2014Bold pt-5"
                style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">PAYMENTS
                ADDRESS
            </h3>
            <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">PO Box 935358</h5>
            <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">Atlanta, GA 31193-5385
            </h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">P: <a class="telephoneNmbr" href='tel:800-780-2774'>800-780-2774 x3</a></h5>
        </div>
        <div class="col-lg-4 whiteText mailingAddressOuter">
            <h3 class="DIN2014Bold pt-5 pt-md-0"
                style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">MAILING ADDRESS
            </h3>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">PO Box 807</h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">Lakeland, FL 33802</h5>

            <h3 class="DIN2014Bold pt-5"
                style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">EMERGENCY
                NUMBERS
            </h3>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">PRODUCT: <a class="telephoneNmbr" href='tel:800-304-0824'>800-304-0824</a>
            </h5>
            <h5 class="DIN2014Regular" style="color:white !important; font-size:19px; line-height:27px; font-weight:400">TRANSPORTATION:
                <a class="telephoneNmbr" href='tel:800-424-9300'>800-424-9300</a>
            </h5>
            <h3 class="DIN2014Bold pt-5"
                style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">HUMAN RESOURCES
            </h3>
            <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">HR&#64;Harrells.com
            </h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">F: <a href="javascript: void(0)" style="color:white !important">863-688-8836</a></h5>
        </div>
        <div class="col-lg-4 whiteText creditContactOuter">
            <h3 class="DIN2014Bold pt-5 pt-md-0"
                style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">CREDIT CONTACT
            </h3>
            <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">Credit&#64;Harrells.com
            </h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">P: <a class="telephoneNmbr" href='tel:800-780-2774'>800-780-2774 x5</a></h5>
            <h5 class="DIN2014Regular" style="color:white !important;font-size:19px; line-height:27px; font-weight:400">F: <a href="javascript: void(0)" style="color:white !important">863-583-0695</a></h5>
        </div>
    </div>
</div>
<div style="max-width:1350px; margin:auto">
    <div class="whiteBackground mb-5" id="warehouses" style="text-align: left; margin-left:10%; margin-right:10%;">
        <div class="row mt-5 mb-3">
            <h2 class="Caecilia76BoldItalic greenText" style="font-size:28px; font-weight: 700; ">Our Warehouses</h2>
        </div>
        <!-- expandable warehouse list - grid of warehouses -->
        <div *ngFor="let warehouse of this.dotComService.warehouses" style="border-bottom:solid 1px #b9b6b6;">
            <div class="row" (click)="ToggleExpand(warehouse)">
                <h6 class="DIN2014Regular"
                    style="padding-bottom:20px;margin-top:30px;display:inline-block;font-size:21px; line-height:25px; font-weight:400px; letter-spacing: 0.42px">
                    {{warehouse.alt_name | uppercase}}
                    <img *ngIf="this.warehouseToDisplay == warehouse.Id" src="{{this.pageImagePaths + 'up-arrow.png'}}"
                        alt="arrow up" style="cursor:pointer;float:right;margin-top:10px">
                    <img *ngIf="this.warehouseToDisplay != warehouse.Id"
                        src="{{this.pageImagePaths + 'down-arrow.png'}}" alt="arrow down"
                        style="cursor:pointer;float:right;margin-top:10px">
                </h6>
            </div>
            <!-- warehouse info - displays if expanded -->
            <div *ngIf="this.warehouseToDisplay == warehouse.Id">
                <div class="row mb-2"  id="{{warehouse.name}}">
                    <div class="col-md-6">
                        <h6 class="DINNextLTPro-Black" style="font-size:30px; font-weight:900; line-height:36px;">
                            {{warehouse.name}}</h6>
                        <img src="{{this.pageImagePaths + 'location-icon.png'}}" alt="phone icon"
                            style="display:inline-block;cursor:pointer;margin-top:-2px">
                        <h6 class="DIN2014Regular"
                            style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                            {{warehouse.address}}</h6>
                        <h6 class="DIN2014Regular"
                            style="margin-left:30px;font-size:19px; font-weight:400; line-height:30px;">
                            {{warehouse.city}}, {{warehouse.state}} {{warehouse.zip}}</h6>
                        <img src="{{this.pageImagePaths + 'call-icon.png'}}" alt="phone icon"
                            style="display:inline-block;cursor:pointer;margin-top:-2px">
                        <h6 class="DIN2014Regular"
                            style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                            <a class="telephoneNmbr" href='tel:{{warehouse.phone}}'>{{warehouse.phone}}</a></h6>
                        <h3 style="margin-top:20px"><a class="DIN2014Bold lightBlueBackground blueText"
                                style="cursor:pointer;font-size:20px ;padding:8pt; text-decoration: none !important"
                                (click)="GetDirections(warehouse)">GET
                                DIRECTIONS</a>
                        </h3>
                    </div>
                    <div class="d-none d-md-inline col-xs-12 col-sm-12 col-md-6">
                        <google-map height="340px" width="540px" [options]="options">
                            <!-- red pin marker goes inside the map tags-->
                            @for (location of nzLocations; track location) {
                            <map-advanced-marker #markerElem="mapAdvancedMarker"
                                [position]="{ lat: location.lat, lng: location.lng }" />
                            }
                            <!-- red pin marker goes inside the map tags-->
                        </google-map>

                    </div>
                    <div class="d-inline d-md-none col-xs-12" style="margin-top:20px">
                        <google-map height="80vw" width="80vw" [options]="options">
                            <!-- red pin marker goes inside the map tags-->
                            @for (location of nzLocations; track location) {
                            <map-advanced-marker #markerElem="mapAdvancedMarker"
                                [position]="{ lat: location.lat, lng: location.lng }" />
                            }
                            <!-- red pin marker goes inside the map tags-->
                        </google-map>

                    </div>
                </div>
                <div class="row mb-3 empGridContainer">
                    <h6 class="DINNextLTPro-Black mt-5" style="font-size:30px; font-weight:900; line-height:36px;">
                        {{warehouse.name.replace('Warehouse','Operations')}}</h6>

                        <div class="col-lg-4 p-0" *ngFor="let emp of warehouse.employees" >
                            <div class="text-center" (mouseenter)="ChangeOpacity(emp.Id)" (mouseleave)="ChangeOpacityBack(emp.Id)">
                                <img class="empImage" id={{emp.Id}} src={{emp.empPhoto}} alt="emp image">
                                <div [id]="emp.Id+'detail'" style="display:none; position:relative; margin-top:-200px;width:345px;height:200px">
                                    <h5 class="DIN2014Regular"
                                        style="width:80%;font-size:21px; line-height: 19px; font-weight:700;letter-spacing: .42px; padding-top:20px;margin-left:auto; margin-right: auto">
                                        {{emp.FirstName|uppercase}} {{emp.LastName|uppercase}}</h5>
                                    <h5 class="DIN2014Regular"
                                        style="width:80%;text-transform:capitalize; font-size:19px; line-height: 19px; font-weight:400; letter-spacing: .38px; margin-left:auto; margin-right: auto">
                                        {{emp.Title}}</h5>
                                </div>
                            </div>
                        </div>

                    <!-- <div class="row" style="margin-top:20px; margin-bottom:20px;margin-left: 0px; margin-right:0px;padding-left:0px; padding-right:0px">
                        <div *ngFor="let emp of warehouse.employees" class="col-md-4 pl-0 pr-0">
                            <img class="empPhoto" src="{{emp.empPhoto}}" alt="emp photo"
                                title="{{emp.FirstName}} {{emp.LastName }} ({{emp.Title}})"
                                style="display:inline-block;cursor:pointer;width:343px; height:343px">
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>